<div class="payment-result__state payment-result__state--non-payment-image">
  <p>
    La imagen enviada no corresponde a algún tipo de comprobante.
    <br />
    Por favor, envía una imagen válida.
  </p>
</div>
